<template>
<div id="app">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <el-button class="btn-primary" @click="addTo(formInline)">保存</el-button>
                </div>
                <div class="ibox-content">
                    <el-form class="form-horizontal m-t" :rules="validation" ref="formInline" :model="formInline" label-width="100px" label-position="right">
                        <el-form-item label="转诊医院：" prop="referralName" :span="15" style="width:40%">
                                <el-col>
                                    <el-input  v-model="formInline.referralName" placeholder="请输入转诊医院名称" maxlength="30"></el-input>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="医院地址：" required>
                              <el-col :span="3">
                                  <el-form-item label="" prop="provinceId" >
                                    <el-select v-model="formInline.provinceId" placeholder="请选择省" v-on:change="onChangePro(formInline.provinceId)">
                                        <el-option v-for="item in selectpro" :key="item.id" :label="item.name" :value="item.id+''"></el-option>
                                    </el-select>
                                  </el-form-item>
                              </el-col>
                              <el-col :span="3">
                                  <el-form-item label="" prop="cityId" label-width="10px">
                                      <el-select v-model="formInline.cityId" placeholder="请选择市" v-on:change="onChangeCity(formInline.cityId)">
                                          <el-option v-for="item in selectcity" :key="item.id" :label="item.name" :value="item.id+''"></el-option>
                                      </el-select>
                                  </el-form-item>
                              </el-col>
                              <el-col :span="3">
                                <el-form-item label="" prop="districtId" label-width="10px">
                                    <el-select v-model="formInline.districtId" placeholder="请选择区">
                                        <el-option v-for="item in selectarea" :key="item.id" :label="item.name" :value="item.id+''"></el-option>
                                    </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="6">
                                <el-form-item label="" prop="address" label-width="10px">
                                    <el-input v-model="formInline.address" placeholder="请输入医院地址" maxlength="50"></el-input>
                                </el-form-item>
                              </el-col>
                            </el-form-item>
                    </el-form>
                    <p style="color:#18a689;position:relative;left:18px;">友情提示：修改转诊信息后，直接管辖幼儿园下发转诊单时将默认转诊至已设置的医院</p>
                </div>
          </div>
      </div>
    </div>
</div>
</template>
<script>
import config from '../../com/config'
import api from '../../com/ajax' // 改成对应的路径

export default {
  name: 'app',
  data () {
    return {
      formInline: {
        referralName: '', // 姓名
        provinceId: '', // 联系省
        cityId: '', // 联系市
        districtId: '', // 联系区县
        address: ''// 地址
      },
      selectpro: [], // 省集合
      selectcity: [], // 市集合
      selectarea: [], // 区县集合
      getParentID: '',
      getCityID: '',
      getID: '',
      item: [],
      getCID: '',
      validation: {
        referralName: [
                    { required: true, message: '请填写转诊医院', trigger: 'blur' }
        ],
        provinceId: [
                    { required: true, message: '请选择省', trigger: 'blur' }
        ],cityId: [
                    { required: true, message: '请选择市', trigger: 'blur' }
        ],districtId: [
                    { required: true, message: '请选择区', trigger: 'blur' }
        ],address: [
                    { required: true, message: '请输入医院地址', trigger: 'blur' }
        ]
      }

    }
  },
  methods: {
    addTo () {
      let that = this
      that.$refs.formInline.validate((valid) => {
        if (valid) {
          api.post(config.host + 'referral/editReferral.do', that.formInline).then((response) => {
            if (response.success == true) {
              that.$message.success('修改成功')
              that.$router.push({path: '/detail'})
            } else {
              that.$message.error(response.msg)
            }
          })
        }
      })
    },
    onChangePro (parentID) { // 省市区联动
      let self = this
      if (parentID === '' || parentID === undefined) {
        self.getParentID = 0
      } else {
        self.getParentID = self.formInline.provinceId
      }
      if (self.getParentID === '' || self.getParentID === undefined) {
        self.getParentID = 0
      }
      if (self.getParentID !== 'undefined') {
        api.post(config.host + 'common/getAreasList.do', { 'parentID': self.getParentID }).then((response) => {
          if (response.success === true) {
            self.selectcity = response.body.list
            self.formInline.districtId = ''
            if (self.item.cityId === '') {
              self.formInline.cityId = ''
            } else {
              self.formInline.cityId = self.item.cityId + ''
              self.item.cityId = ''
            }
          }
        })
      }
    },
    onChangeCity (parentID) { // 省市区联动
      let self = this
      if (parentID === '' || parentID === undefined) {
        self.getCityID = 0
      } else {
        self.getCityID = self.formInline.cityId
      }
      if (self.getCityID === '' || self.getCityID === undefined) {
        self.getCityID = 0
      }
      if (self.getCityID !== 'undefined') {
        api.post(config.host + 'common/getAreasList.do', { 'parentID': self.getCityID }).then((response) => {
          if (response.success === true) {
            self.selectarea = response.body.list

            if (self.item.districtId === '') {
              self.formInline.districtId = ''
            } else {
              self.formInline.districtId = self.item.districtId+''
              self.item.districtId = ''
            }
          }
        })
      }
    },
    loadInit:function(){
      let self = this
        api.post(config.host + 'referral/getReferralByOrgId.do',{}).then((data) => {
        if (data.success == true) {
          if(data.body){
            self.item=data.body;
            self.formInline.referralName=self.item.referralName;
            self.formInline.address=self.item.address;
            // 加载省市区各列表
          api.post(config.host + 'common/getAreasList.do', {parentID: 0}).then((data) => {
            if (data.success == true) {
              self.selectpro = data.body.list
              if (self.item.provinceId != '' && self.item.provinceId != undefined) {
                self.formInline.provinceId = self.item.provinceId + ''
              } else {
                self.formInline.provinceId = ''
              }
            }
          })
        }
      }
    })
  }
  },
  watch: {
    $route: {
      handler: function () {
        this.loadInit()
      },
      deep: true
    },
    'formInline.provinceId': function (val) {
      var self = this
      self.$nextTick(function () {
        if (val === '' || val === undefined) {
          self.getID = 0
        } else {
          self.getID = val
        }
        if (self.getID !== 'undefined') { self.onChangePro(self.getID) }
      })
    },
    'formInline.cityId': function (val) {
      var self = this
      self.$nextTick(function () {
        if (val === '' || val === undefined) {
          self.getCID = 0
        } else {
          self.getCID = val
        }
        if (self.getCID !== 'undefined') { self.onChangeCity(self.getCID) }
      })
    }
  },
  created: function () {
    this.loadInit()
  }

}
</script>



// WEBPACK FOOTER //
// src/components/referral/referralEdit.vue?0ee24f62